module.exports = __webpack_public_path__ + "media/images/emoticons/delicious-aefeea00ff4f28dbbfd50adeaee683a5.gif";